import React from 'react'
import { useState } from "react";
import { Button } from "@material-ui/core";
import { Helmet } from "react-helmet";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation } from "swiper/modules";
import NewHead from "../../landing/NewHead";
import ServiceFooter from "../../ServiceFooter";
import './OwnBlockchainNew.css'
import { GoArrowUpRight } from "react-icons/go";
import 'swiper/css';
import 'swiper/css/navigation';
import { Pagination } from 'swiper/modules';

function OwnBlockchainNew() {
  return (
     <>
          <NewHead />
    
          <div className="own_block_chain_development_page">
            <div className="paddin_immner">
              <main className="own_block_chain_main">
                <span className="own_block_chain_development_company_main">
                  <Helmet>
                    <title>Build your own blockchain</title>
                    <link   
                      rel="canonical"
                      href="https://www.beleaftechnologies.com/own-blockchain-development-company"
                    />
                    <meta name="title" content="Build your own blockchain" />
                    <meta
                      name="description"
                      content="Our company specializes in creating own blockchain development for your specific needs. Whether you are a startup, a small business, or a large enterprise, we are here to help you unlock the potential of blockchain and transform your operations."
                    />
                  </Helmet>
               
                </span>
 {/* section 1 */}

                <article className='ownBlockChain_hero_sct ownBlockChain_commn_sct'>
                    <div className='ownBlockChain_hero_cont ownBlockChain_commn_cont primary__landing__container'>
                        <div className='ownBlockChain_hero_wrp'>
                            <div className='ownBlockChain_hero_ContTop'>
                                <h1>Build your own blockchain</h1>
                                <p>
                                    Welcome to the world's no 1 Own Blockchain Development Company ! If you are looking to use the power of blockchain technology for your business, you’ve come to the right place.
                                </p>
                               <div className='ownBlockChain_star_btn'>
                     <button className='ownBlockChain_cmmn_Btn1' data-toggle="modal"
                          data-target="#myModal"
                          aria-label="Contact Us"
                           >
                                    <span className="MuiButton-label ownBlockChain_cmmn_Btn1Txt">Free demo</span>

                                <span className='ownBlockChain_cmmn_Btn1Arrw'>
                                                {/* <HiArrowRight /> */}
                                                <GoArrowUpRight  className='ownBlockChain_cmmn_Btn1Arrw1' />
                                                <GoArrowUpRight  className='ownBlockChain_cmmn_Btn1Arrw2' />
                                                {/* <LuArrowRight /> */}
                                                {/* <LuArrowRight /> */}
                                            </span>
                                        </button>
                     </div> 
                            </div>
                            <div className='ownBlockChainHeroImg'>
                                <img src={new URL("../../../image/ownBlockChainNew/ownBlockChain_hero_img.webp", import.meta.url)} alt='own-blockchain-development-company' />
                            </div>
                        </div>
                    </div>
                </article>
                
 {/* section 2 */}
     
      <article className='ownBlockChain_wht_sct ownBlockChain_commn_sct'>
               <div className='ownBlockChain_wht_cont ownBloackChain_commn_cont primary__landing__container'>
                 <div className='ownBlockChain_wht_wrp'>
                      <div className='ownBlockChain_wht_lft'>
                       <img className='ownBlockChain_wht_Topimg' src={require("../../../image/ownBlockChainNew/ownBlockChain_Wht_img.webp")} alt="own-blockchain-development-company"/>
                   </div>
                    <div className='ownBlockChain_wht_rgt'>
                  
                     <h2 className='ownBlockChain_wht_title ownBlockChain_common_title'>What is Own Blockchain Development?</h2>
                     <p className='ownBlockChain_wht_desp ownBlockChain_common_desp'>Own blockchain development refers to the process of developing a blockchain to meet the exact requirements of an entity or organization.</p>
                     <p className='ownBlockChain_wht_desp ownBlockChain_common_desp'>Unlike public blockchains like Bitcoin or Ethereum, which are open to anyone, an own blockchain is designed exclusively for a particular entity or organisation. This allows for security, greater control, and customization.</p>
<div className='ownBlockChain_wht_btn'>
        <button className='ownBlockChain_cmmn_Btn1' data-toggle="modal"
                          data-target="#myModal"
                          aria-label="Contact Us"
                         >
                                    <span className="MuiButton-label ownBlockChain_cmmn_Btn1Txt">Contact Us</span>

                                <span className='ownBlockChain_cmmn_Btn1Arrw'>
                                                {/* <HiArrowRight /> */}
                                                <GoArrowUpRight  className='ownBlockChain_cmmn_Btn1Arrw1' />
                                                <GoArrowUpRight  className='ownBlockChain_cmmn_Btn1Arrw2' />
                                                {/* <LuArrowRight /> */}
                                                {/* <LuArrowRight /> */}
                                            </span>
                                        </button>
</div>
                  
                     
                     
                   </div>
                   
                 
                   
                 </div>
               </div>
             </article>

      {/* section 3 */}

                <article className='ownBlockChain_feature_sct ownBlockChain_commn_sct' id=''>
                    <div className='ownBlockChain_feature_cont ownBlockChain_commn_cont primary__landing__container'>
                        <div className='ownBlockChain_feature_wrp'>

                            <div className='ownBlockChain_feature_Rgt'>
                                <h2 className='ownBlockChain_feature_title ownBlockChain_common_title'>Key Features of Our Own Blockchain Development</h2>
                            </div>

                            <div                                                                                    >

                                <Swiper navigation={true} pagination={true} modules={[Navigation,Pagination]} loop className="mySwiper OwnBlockChain_feature_swiper" breakpoints={{
                                    640: {
                                        slidesPerView: 1,
                                        spaceBetween: 50,
                                    },
                                    768: {
                                        slidesPerView: 2,
                                        spaceBetween: 40,
                                    },

                                    992: {
                                        slidesPerView: 2.5,
                                        spaceBetween: 50,
                                    },
                                    1200: {
                                        slidesPerView: 3.2,
                                        spaceBetween: 50,
                                    },
                                }}>
                                   
                                    <SwiperSlide>
                                        <div className='ownBlockChain_feature_sliderWrp'>
                                            <div className='ownBlockChain_feature_sliderlft'>
                       <img className='ownBlockChain_wht_Topimg' src={require("../../../image/ownBlockChainNew/ownblockChain_feature_img1.webp")} alt="own-blockchain-development-company"/>

                                            </div>
                                            <div className='ownBlockChain_feature_sliderrgt'>
                                                <h3>Customization</h3>
                                                <p>You can develop the blockchain to suit your specific needs, from transaction processing to governance models.</p>
                                            </div>
                                        </div>
                                    </SwiperSlide>
                                    <SwiperSlide>
                                        <div className='ownBlockChain_feature_sliderWrp'>
                                            <div className='ownBlockChain_feature_sliderlft'>
                       <img className='ownBlockChain_wht_Topimg' src={require("../../../image/ownBlockChainNew/ownblockChain_feature_img2.webp")} alt="own-blockchain-development-company"/>

                                            </div>
                                            <div className='ownBlockChain_feature_sliderrgt'>
                                                <h3>Security</h3>
                                                <p>With your own blockchain, you can implement advanced security measures to protect your data and transactions.</p>
                                            </div>
                                        </div>
                                    </SwiperSlide>
                                    <SwiperSlide>
                                          <div className='ownBlockChain_feature_sliderWrp'>
                                            <div className='ownBlockChain_feature_sliderlft'>
                       <img className='ownBlockChain_wht_Topimg' src={require("../../../image/ownBlockChainNew/ownblockChain_feature_img3.webp")} alt="own-blockchain-development-company"/>

                                            </div>
                                            <div className='ownBlockChain_feature_sliderrgt'>
                                                <h3>Efficiency</h3>
                                                <p>Own blockchain development can be optimized for performance, ensuring fast and efficient transaction processing.</p>
                                            </div>
                                        </div>
                                    </SwiperSlide>
         <SwiperSlide>
                                          <div className='ownBlockChain_feature_sliderWrp'>
                                            <div className='ownBlockChain_feature_sliderlft'>
                       <img className='ownBlockChain_wht_Topimg' src={require("../../../image/ownBlockChainNew/ownblockChain_feature_img4.webp")} alt="own-blockchain-development-company"/>

                                            </div>
                                            <div className='ownBlockChain_feature_sliderrgt'>
                                                <h3>Control</h3>
                                                <p>You have complete control over the blockchain network, including who can participate and how it operates.</p>
                                            </div>
                                        </div>
                                    </SwiperSlide>
                                             <SwiperSlide>
                                          <div className='ownBlockChain_feature_sliderWrp'>
                                            <div className='ownBlockChain_feature_sliderlft'>
                       <img className='ownBlockChain_wht_Topimg' src={require("../../../image/ownBlockChainNew/ownblockChain_feature_img5.webp")} alt="own-blockchain-development-company"/>

                                            </div>
                                            <div className='ownBlockChain_feature_sliderrgt'>
                                                <h3>Scalability</h3>
                                                <p>Own blockchains can be designed to scale according to your business growth and needs.</p>
                                            </div>
                                        </div>
                                    </SwiperSlide>
                                </Swiper>
                            </div>

                        </div>
                    </div>
                </article>

 {/* section -4  */}
              <article className='ownBlockChain_how_sct ownBlockChain_commn_sct'>
          <div className='ownBlockChain_how_cont ownBlockChain_commn_cont primary__landing__container'>
            <div className='ownBlockChain_how_wrp'>
 <div className='ownBlockChain_how_lft'>
                <h2 className='ownBlockChain_how_title ownBlockChain_common_title'>How to Choose an Own Blockchain Development Company</h2>
              </div>
            <div className='ownBlockChain_how_rgt'>
                 <div className='ownBlockChain_how_lstItm ownBlockChain_how_lstItmsmll'>
                       <div className='ownBlockChain_how_lstItmlft'>
                   <div className='ownBlockChain_how_lstItmrgt'>
                 <div>
                  <div className='ownBlockChain_how_outercircle'>
                    <img className='ownBlockChain_how_innerImg' src={require("../../../image/ownBlockChainNew/ownBlockChain_own_innerCircle_img1.webp")} alt="own-blockchain-development-company" />

                    <div className='ownBlockChain_how_innercircle'>
                      <img className='ownBlockChain_how_outerImg' src={require("../../../image/ownBlockChainNew/ownBlockChain_own_outer_img.webp")} alt="own-blockchain-development-company" />

     
                    </div>
                  </div>
                 </div>
                </div>  
                   <h3 className='ownBlockChain_how_lstItm_title'>Expertise and Experience</h3>
                  <p className="ownBlockChain_how_lstItm_desp">Choose a company with a proven track record in Own blockchain development. Check their portfolio to see the types of projects they have worked on and their level of expertise in different blockchain technologies.</p>
                </div>
             
              </div>
                 <div className='ownBlockChain_how_lstItm ownBlockChain_how_lstItmsmll'>
                       <div className='ownBlockChain_how_lstItmlft'>
                  <div className='ownBlockChain_how_lstItmrgt'>
                 <div>
                  <div className='ownBlockChain_how_outercircle'>
                    <img className='ownBlockChain_how_innerImg' src={require("../../../image/ownBlockChainNew/ownBlockChain_own_innerCircle_img2.webp")} alt="own-blockchain-development-company" />

                    <div className='ownBlockChain_how_innercircle'>
                      <img className='ownBlockChain_how_outerImg' src={require("../../../image/ownBlockChainNew/ownBlockChain_own_outer_img.webp")} alt="own-blockchain-development-company" />

     
                    </div>
                  </div>
                 </div>
                </div>  
                   <h3 className='ownBlockChain_how_lstItm_title'>Customization and Flexibility</h3>
                  <p className="ownBlockChain_how_lstItm_desp">Your business is unique, and so your requirements must be unique. Choose a Own blockchain development company that offers customised solutions. They should be flexible in their approach and willing to adapt to your requirements.</p>
                </div>
             
              </div>
               <div className='ownBlockChain_how_lstItm ownBlockChain_how_lstItmsmll'>
                       <div className='ownBlockChain_how_lstItmlft'>
                     <div className='ownBlockChain_how_lstItmrgt'>
                 <div>
                  <div className='ownBlockChain_how_outercircle'>
                    <img className='ownBlockChain_how_innerImg' src={require("../../../image/ownBlockChainNew/ownBlockChain_own_innerCircle_img3.webp")} alt="own-blockchain-development-company" />

                    <div className='ownBlockChain_how_innercircle'>
                      <img className='ownBlockChain_how_outerImg' src={require("../../../image/ownBlockChainNew/ownBlockChain_own_outer_img.webp")} alt="own-blockchain-development-company" />

     
                    </div>
                  </div>
                 </div>
                </div>   
                   <h3 className='ownBlockChain_how_lstItm_title'>Security Measures</h3>
                  <p className="ownBlockChain_how_lstItm_desp">Security is essential in blockchain development. Ensure the company you choose implements robust security measures to protect your data and transactions. They should follow blockchain security best practices and have experience handling security challenges.</p>
                </div>
             
              </div>
              <div className='ownBlockChain_how_lstItm ownBlockChain_how_lstItmlrg'>
                <div className='ownBlockChain_how_lstItmlft'>
                    <div className='ownBlockChain_how_lstItmrgt'>
                 <div>
                  <div className='ownBlockChain_how_outercircle'>
                    <img className='ownBlockChain_how_innerImg' src={require("../../../image/ownBlockChainNew/ownBlockChain_own_innerCircle_img4.webp")} alt="own-blockchain-development-company" />

                    <div className='ownBlockChain_how_innercircle'>
                      <img className='ownBlockChain_how_outerImg' src={require("../../../image/ownBlockChainNew/ownBlockChain_own_outer_img.webp")} alt="own-blockchain-development-company" />

     
                    </div>
                  </div>
                 </div>
                </div> 
                  <h3 className="ownBlockChain_how_lstItm_title">Comprehensive Serices</h3>
                  <p className='ownBlockChain_how_lstItm_desp'>A good blockchain development company should offer end-to-end services, from consulting and strategy to design, development, and implementation. This ensures a hassle free and efficient process, reducing the risk of delays and complications.</p>
                </div>
              
              </div>
             
               <div className='ownBlockChain_how_lstItm ownBlockChain_how_lstItmlrg'>
                <div className='ownBlockChain_how_lstItmlft'>
                 <div className='ownBlockChain_how_lstItmrgt'>
                 <div>
                  <div className='ownBlockChain_how_outercircle'>
                    <img className='ownBlockChain_how_innerImg' src={require("../../../image/ownBlockChainNew/ownBlockChain_own_innerCircle_img5.webp")} alt="own-blockchain-development-company" />

                    <div className='ownBlockChain_how_innercircle'>
                      <img className='ownBlockChain_how_outerImg' src={require("../../../image/ownBlockChainNew/ownBlockChain_own_outer_img.webp")} alt="own-blockchain-development-company" />

     
                    </div>
                  </div>
                 </div>
                </div> 
                  <h3 className="ownBlockChain_how_lstItm_title">Support and Maintenance</h3>
                  <p className='ownBlockChain_how_lstItm_desp'>Blockchain technology is constantly developing, and your blockchain solution will need regular updates and maintenance. Choose a company that offers ongoing support and maintenance services to ensure your blockchain continues to perform optimally.</p>
                </div>
              
              </div>
            
            </div>
            </div>
             
          </div>
        </article>

 {/* section - 5  */}
              <article className='ownBlockChain_own_sct ownBlockChain_commn_sct'>
          <div className='ownBlockChain_own_cont ownBlockChain_commn_cont primary__landing__container'>
            <div className='ownBlockChain_own_wrp'>
 <div className='ownBlockChain_own_lft'>
                <h2 className='ownBlockChain_own_title ownBlockChain_common_title'>Use Cases of Own Blockchain Development</h2>
                <p className='ownBlockChain_own_desp ownBlockChain_common_desp'>Own blockchain development can be applied across various industries to improve efficiency, security, and transparency.
Here are some use cases:</p>
              </div>
            <div className='ownBlockChain_own_rgt'>
              <div className='ownBlockChain_own_lstItm ownBlockChain_own_lstItmlrg'>
                <div className='ownBlockChain_own_lstItmlft'>
                    <div className='ownBlockChain_own_lstItmrgt'>
                  <img className='ownBlockChain_own_Topimg' src={require("../../../image/ownBlockChainNew/ownBlockChain_own_img1.webp")} alt="own-blockchain-development-companyt" />

                </div>
                <div>
                  <h3 className="ownBlockChain_own_lstItm_title">Supply chain</h3>
                  <p className='ownBlockChain_own_lstItm_desp'>Blockchain technology can change supply chain management by providing a transparent and immutable record of transactions. This helps in tracking products from origin to delivery, reducing fraud, and improving efficiency.</p>
                </div>
                  
                </div>
              
              </div>
            <div className='ownBlockChain_own_lstItm ownBlockChain_own_lstItmlrg'>
                <div className='ownBlockChain_own_lstItmlft'>
                    <div className='ownBlockChain_own_lstItmrgt'>
                  <img className='ownBlockChain_own_Topimg' src={require("../../../image/ownBlockChainNew/ownBlockChain_own_img2.webp")} alt="own-blockchain-development-company" />
                </div>
                <div>
                  <h3 className="ownBlockChain_own_lstItm_title">Finance and Banking</h3>
                  <p className='ownBlockChain_own_lstItm_desp'>In the finance and banking sector, blockchain can enhance security and reduce transaction costs. It can be used for cross-border payments, smart contracts, and fraud detection.</p>
                </div>
                  
                </div>
              
              </div>
               <div className='ownBlockChain_own_lstItm ownBlockChain_own_lstItmlrg'>
                <div className='ownBlockChain_own_lstItmlft'>
                    <div className='ownBlockChain_own_lstItmrgt'>
                  <img className='ownBlockChain_own_Topimg' src={require("../../../image/ownBlockChainNew/ownBlockChain_own_img3.webp")} alt="own-blockchain-development-company" />
                </div>
                <div>
                  <h3 className="ownBlockChain_own_lstItm_title">Healthcare</h3>
                  <p className='ownBlockChain_own_lstItm_desp'>Blockchain can improvise data security in the healthcare industry. It can be used for managing patient records, ensuring data integrity and streamlining administrative processes.</p>
                </div>
                  
                </div>
              
              </div>
                <div className='ownBlockChain_own_lstItm ownBlockChain_own_lstItmlrg'>
                <div className='ownBlockChain_own_lstItmlft'>
                    <div className='ownBlockChain_own_lstItmrgt'>
                  <img className='ownBlockChain_own_Topimg' src={require("../../../image/ownBlockChainNew/ownBlockChain_own_img4.webp")} alt="own-blockchain-development-company" />
                </div>
                <div>
                  <h3 className="ownBlockChain_own_lstItm_title">Real Estate</h3>
                  <p className='ownBlockChain_own_lstItm_desp'>In real estate, blockchain can simplify property transactions and improve transparency. It can be used for property listings, title transfers, and lease agreements.</p>
                </div>
                  
                </div>
              
              </div>
            </div>
            </div>
             
          </div>
        </article>

 {/* section - 6  */}
              <article className='ownBlockChain_types_sct ownBlockChain_commn_sct'>
          <div className='ownBlockChain_types_cont ownBlockChain_commn_cont primary__landing__container'>
            <div className='ownBlockChain_types_wrp'>
 <div className='ownBlockChain_types_lft'>
                <h2 className='ownBlockChain_types_title ownBlockChain_common_title'>Types of Blockchains We Develop</h2>
                <p className='ownBlockChain_types_desp ownBlockChain_common_desp'>At Beleaf Technologies, we specialize in developing various types of blockchain solutions. Our expertise ensures that you get the best own blockchain solution that fits your specific requirements. Here are the main types of blockchains we develop.</p>
              </div>
            <div className='ownBlockChain_types_rgt'>
              <div className='ownBlockChain_types_lstItm ownBlockChain_types_lstItmsmll'>
                <div className='ownBlockChain_types_lstItmlft'>
                    <div className='ownBlockChain_types_lstItmrgt'>
                   <span>01</span>
                </div>
                <div>
                  <h3 className="ownBlockChain_types_lstItm_title">Public Blockchain</h3>
                  <p className='ownBlockChain_types_lstItm_desp'>These are open to anyone and are decentralized, meaning no single person or organisation has control over the network. Transactions are transparent and can be verified by any participant. Public blockchains are ideal for applications that require high levels of transparency and decentralization, such as cryptocurrencies (e.g., Bitcoin, Ethereum).</p>
                </div>
                  
                </div>
              
              </div>
            <div className='ownBlockChain_types_lstItm ownBlockChain_types_lstItmsmll'>
                <div className='ownBlockChain_types_lstItmlft'>
                    <div className='ownBlockChain_types_lstItmrgt'>
                   <span>02</span>
                </div>
                <div>
                  <h3 className="ownBlockChain_types_lstItm_title">Private Blockchains</h3>
                  <p className='ownBlockChain_types_lstItm_desp'>These are restricted to specific participants. They are controlled by a single organization, which grants access and permissions. Private blockchains are ideal for businesses that need to maintain control over their data while benefiting from the security and efficiency of blockchain technology.</p>
                </div>
                  
                </div>
              
              </div>
               <div className='ownBlockChain_types_lstItm ownBlockChain_types_lstItmsmll'>
                <div className='ownBlockChain_types_lstItmlft'>
                    <div className='ownBlockChain_types_lstItmrgt'>
                    <span>03</span>
                </div>
                <div>
                  <h3 className="ownBlockChain_types_lstItm_title">Consortium Blockchains</h3>
                  <p className='ownBlockChain_types_lstItm_desp'>Consortium Blockchains are partially decentralized and managed by a group of organizations rather than a single entity. They are ideal for business collaborations where multiple organizations need to work together but still want to maintain some level of control over the network.</p>
                </div>
                  
                </div>
              
              </div>
                 <div className='ownBlockChain_types_lstItm ownBlockChain_types_lstItmsmll'>
                <div className='ownBlockChain_types_lstItmlft'>
                    <div className='ownBlockChain_types_lstItmrgt'>
                    <span>04</span>
                </div>
                <div>
                  <h3 className="ownBlockChain_types_lstItm_title">Hybrid Blockchains</h3>
                  <p className='ownBlockChain_types_lstItm_desp'>Combine the features of both Private and Public blockchains. They allow organizations to control access to specific data while keeping some information public. This type of blockchain offers the transparency of public blockchains with the control of private blockchains.</p>
                </div>
                  
                </div>
              
              </div>
                <div className='ownBlockChain_types_lstItm ownBlockChain_types_lstItmlrg'>
                <div className='ownBlockChain_types_lstItmlft'>
                    <div className='ownBlockChain_types_lstItmrgt'>
                    <span>05</span>
                </div>
                <div>
                  <h3 className="ownBlockChain_types_lstItm_title">Sidechains</h3>
                  <p className='ownBlockChain_types_lstItm_desp'>Sidechains  are open to anyone and are decentralized, meaning no single person or organisation has control over the network. Transactions are transparent and can be verified by any participant. Public blockchains are ideal for applications that require high levels of transparency and decentralization, such as cryptocurrencies (e.g., Bitcoin, Ethereum).</p>
                </div>
                  
                </div>
              
              </div>
            </div>
            </div>
             
          </div>
        </article>

{/* section - 7  */}


 <article className='ownBlockChain_free_sct ownBlockChain_commn_sct'>
               <div className='ownBlockChain_free_cont ownBlockChain_commn_cont primary__landing__container'>
                 <div className='ownBlockChain_free_wrp'>
                    <div className='ownBlockChain_free_lft'>
                  
                     <h2 className='ownBlockChain_free_title ownBlockChain_common_title'>Get Started With Beleaf Technologies</h2>
                     <p className='ownBlockChain_free_desp ownBlockChain_common_desp'>Ready to use the power of own blockchain for your business? Contact us today to schedule a consultation
and learn how Beleaf Technologies can help you achieve your goals. Our team is here to provide expert
guidance and support, ensuring your own blockchain development project is a success.</p>
                      <button className='ownBlockChain_cmmn_Btn2'  data-toggle="modal"
                          data-target="#myModal"
                          aria-label="Contact Us"
                          >
                                    <span className="MuiButton-label ownBlockChain_cmmn_Btn2Txt">Free demo</span>

                                <span className='ownBlockChain_cmmn_Btn2Arrw'>
                                                {/* <HiArrowRight /> */}
                                                <GoArrowUpRight  className='ownBlockChain_cmmn_Btn1Arrw1' />
                                                <GoArrowUpRight  className='ownBlockChain_cmmn_Btn1Arrw2' />
                                                {/* <LuArrowRight /> */}
                                                {/* <LuArrowRight /> */}
                                            </span>
                                        </button>
                     
                     
                   </div>
                     <div className='ownBlockChain_free_rgt'>
                       <img className='ownBlockChain_free_Topimg' src={require("../../../image/ownBlockChainNew/ownBlockChain_free_img.webp")} alt="own-blockchain-development-company"/>
                   </div>
                 
                   
                 </div>
               </div>
             </article>
              </main>
            </div>
          </div>
    
          {/* faq */}
          <article className="primary__landing-content-container">
            <div className="landing-faq-wrapper">
              <div className="row">
                <div className="col-lg-6">
                  <h6 className="landing-faq-left-title">
                    Frequently Asked <span className="faq-span">Questions.</span>{" "}
                    {""}
                  </h6>
                </div>
                <div className="col-lg-6">
                  <div>
                    <div className="container">
                      <div className="accordion" id="faq">
                        <div className="landing-faq-card">
                          <div className="landing-faq-header" id="faqhead1">
                            <button
                              className="landing-faq-title collapsed"
                              type="button"
                              data-toggle="collapse"
                              data-target="#faq1"
                              aria-expanded="true"
                              aria-controls="faq1"
                            >
                              What is blockchain technology?
                            </button>
                          </div>
    
                          <div
                            id="faq1"
                            className="collapse"
                            aria-labelledby="faqhead1"
                            data-parent="#faq"
                          >
                            <div className="landing-faq-content">
                              Blockchain technology is a secure decentralised
                              digital ledger that records transactions across
                              multiple nodes. It ensures data privacy and
                              transparency.
                            </div>
                          </div>
                        </div>
    
                        <div className="landing-faq-card">
                          <div className="landing-faq-header" id="faqhead2">
                            <div
                              className="landing-faq-title collapsed"
                              data-toggle="collapse"
                              data-target="#faq2"
                              aria-expanded="true"
                              aria-controls="faq2"
                            >
                              How does own blockchain development benefit business?
                            </div>
                          </div>
    
                          <div
                            id="faq2"
                            className="collapse"
                            aria-labelledby="faqhead2"
                            data-parent="#faq"
                          >
                            <div className="landing-faq-content">
                              Own blockchain development can enhance security,
                              improve efficiency, and increase transparency in
                              various business processes, reducing costs and
                              improving trust.
                            </div>
                          </div>
                        </div>
    
                        <div className="landing-faq-card">
                          <div className="landing-faq-header" id="faqhead3">
                            <div
                              className="landing-faq-title collapsed"
                              data-toggle="collapse"
                              data-target="#faq3"
                              aria-expanded="true"
                              aria-controls="faq3"
                            >
                              How long does it take to develop a Own blockchain
                              solution?
                            </div>
                          </div>
    
                          <div
                            id="faq3"
                            className="collapse"
                            aria-labelledby="faqhead3"
                            data-parent="#faq"
                          >
                            <div className="landing-faq-content">
                              The development time depends on the complexity and
                              requirements of the project. On average, it can take a
                              few weeks to a month.
                            </div>
                          </div>
                        </div>
    
                        <div className="landing-faq-card">
                          <div className="landing-faq-header" id="faqhead4">
                            <div
                              className="landing-faq-title collapsed"
                              data-toggle="collapse"
                              data-target="#faq4"
                              aria-expanded="true"
                              aria-controls="faq4"
                            >
                              What industries can benefit from Own blockchain
                              development?
                            </div>
                          </div>
    
                          <div
                            id="faq4"
                            className="collapse"
                            aria-labelledby="faqhead4"
                            data-parent="#faq"
                          >
                            <div className="landing-faq-content">
                              Own blockchain development can benefit industries such
                              as finance, healthcare, supply chain, real estate, and
                              more by improving security, efficiency, and
                              transparency.
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </article>
    
          {/* <Footer /> */}
          <ServiceFooter />
        </>
  )
}

export default OwnBlockchainNew